<template>
  <!-- homepage sections -->
  <div class="sections">
    <AboutSection />
    <SkillsSection />
    <ProjectsSection />
    <ArticlesSection />
    <ContactSection />
  </div>
</template>

<script>
import AboutSection from "@/views/home/sections/AboutSection";
import SkillsSection from "@/views/home/sections/SkillsSection";
import ProjectsSection from "@/views/home/sections/ProjectsSection";
import ArticlesSection from "@/views/home/sections/ArticlesSection";
import ContactSection from "@/views/home/sections/ContactSection";

export default {
  name: "Sections",
  components: {
    AboutSection,
    SkillsSection,
    ProjectsSection,
    ArticlesSection,
    ContactSection
  }
};
</script>